import { IAppState } from '../../redux';
import lightFormat from 'date-fns/lightFormat';

const DATE_PATTERN = 'HH:mm';

export function selectTopBetsRequestDateTime(state: IAppState): string {
  const {
    topBets: { requestDateTime },
  } = state;

  return lightFormat(new Date(requestDateTime), DATE_PATTERN);
}
